import { TProps } from './types/TProps';

export const Title = ({ title }: TProps) => {
  if (!title) {
    return null;
  }

  return (
    <h1 className="max-w-[60vw] overflow-hidden text-ellipsis whitespace-nowrap font-semibold text-xl md:text-[25px] leading-[130%] tracking-[0.01em] text-title xl:max-w-[24rem]">
      {title}
    </h1>
  );
};
